import React from 'react';
import { Route as RouterRoute, Redirect, RouteProps } from 'react-router-dom';
import { useAuth } from 'client/auth';

interface RouterRouteProps extends RouteProps {
  path: string;
  element: React.ReactElement;
  exact?: boolean;
}

/**
 * Route wrapper which makes the route component api compatible with react-router @ v6.
 * This makes it easier to type components.
 */
function Route({ path, element, ...props }: RouterRouteProps) {
  return (
    <RouterRoute {...props} path={path}>
      {element}
    </RouterRoute>
  );
}

/**
 * Route wrapper which makes the route component api compatible with react-router @ v6.
 * This makes it easier to type components.
 */
function AuthRoute({ path, element, ...props }: RouterRouteProps) {
  const { data: auth } = useAuth();
  const authenticated = auth?.authenticated;

  if (!authenticated) return <Redirect to="/admin/login" />;
  return (
    <RouterRoute {...props} path={path}>
      {element}
    </RouterRoute>
  );
}

export { Route, AuthRoute };
